import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ConfettiService } from 'src/app/services/conffeti.service';

@Component({
  selector: 'app-onboarding-success',
  templateUrl: './success.page.html',
  standalone: true,
  imports: [IonContent, InlineSVGModule, TranslateModule, RouterModule],
})
export class SuccessPage implements OnInit {
  constructor(
    private router: Router,
    private confettiService: ConfettiService
  ) {}

  ngOnInit() {
    this.confettiService.canon();
  }

  goToFeed() {
    this.router.navigate(['feed'], {
      replaceUrl: true,
    });
  }
}
